import { defineMessages } from 'react-intl';

export default defineMessages({
    defaultPlaceholder: {
        id: '_.select_field.placeholder',
        defaultMessage: 'Select...'
    }
});
